import { get, post, put } from "./authenticatedrequestUtil";

import { Category } from "../../types/Category";


export const getCategories = get<Category[]>(({ companyId }) => `/${companyId}/company/category`);

